export default __webpack_public_path__ + "static/media/keyboard.1b98425a.svg";